import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HomeButton from './HomeButton.jsx'
import Luggage from './Luggage.jsx'
import Groceries from './Groceries.jsx'
import Gifts from './Gifts.jsx'
import PremiumGate from './PremiumGate.jsx'

function Checklists({ userData, onNavigate }) {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState('luggage')

  useEffect(() => {
    if (window.navigationOptions?.initialTab) {
      setActiveTab(window.navigationOptions.initialTab)
      delete window.navigationOptions
    }
  }, [])

  const tabs = [
    { id: 'luggage', name: t('menu.luggage'), icon: '🧳' },
    { id: 'groceries', name: t('menu.groceries'), icon: '🛒' },
    { id: 'gifts', name: t('menu.gifts'), icon: '🎁' }
  ]

  return (
    <div className="container checklists-view" style={{
      background: 'linear-gradient(135deg, #f5f1eb 0%, #ede4d3 100%)',
      minHeight: '100vh',
      padding: '20px',
      position: 'relative'
    }}>
      <HomeButton onNavigate={onNavigate} />

      {/* Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: '30px',
        paddingTop: '60px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '900',
          color: '#8B7355',
          margin: '0 0 8px 0',
          letterSpacing: '2px',
          fontFamily: "'Noto Serif', serif",
          textTransform: 'uppercase'
        }}>{t('checklists.title')}</h1>
      </div>

      {/* Tab Navigation */}
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '8px',
        margin: '0 0 20px 0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        gap: '4px',
        overflowX: 'auto'
      }}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              background: activeTab === tab.id ? '#5B8FA8' : 'transparent',
              color: activeTab === tab.id ? 'white' : '#8B7355',
              border: 'none',
              padding: '12px 16px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              flex: '1',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              transition: 'all 0.3s ease'
            }}
          >
            <div>{tab.icon}</div>
            <div style={{ marginTop: '4px' }}>{tab.name}</div>
          </button>
        ))}
      </div>

      {/* Tab Content — Luggage is premium; Groceries & Gifts are free */}
      {activeTab === 'luggage' && (
        <PremiumGate feature="luggage_management" onNavigate={onNavigate}>
          <Luggage userData={userData} onNavigate={onNavigate} embedded={true} />
        </PremiumGate>
      )}
      {activeTab === 'groceries' && <Groceries userData={userData} onNavigate={onNavigate} embedded={true} />}
      {activeTab === 'gifts' && <Gifts userData={userData} onNavigate={onNavigate} embedded={true} />}

      {/* Back Button */}
      <div style={{ textAlign: 'center', margin: '30px 0 20px 0' }}>
        <button
          style={{
            background: 'transparent',
            color: '#8B7355',
            border: '2px solid #8B7355',
            padding: '12px 24px',
            borderRadius: '25px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={() => onNavigate('home')}
        >
          {t('navigation.backToHome')}
        </button>
      </div>
    </div>
  )
}

export default Checklists
